import { Skeleton } from '@/components/ui/skeleton';

/** Table-shaped skeleton shown while a flattened export view's first page loads. */
export function As400ExportTableSkeleton({
  columnCount,
}: {
  columnCount: number;
}) {
  const cols = Array.from({ length: columnCount });
  return (
    <div className="rounded-md border divide-y overflow-hidden">
      <div className="flex gap-4 px-3 py-2 bg-muted/40">
        {cols.map((_, i) => (
          <Skeleton key={i} className="h-3 w-24 shrink-0" />
        ))}
      </div>
      {Array.from({ length: 10 }).map((_, r) => (
        <div key={r} className="flex gap-4 px-3 py-2.5">
          {cols.map((_, i) => (
            <Skeleton key={i} className="h-4 w-24 shrink-0" />
          ))}
        </div>
      ))}
    </div>
  );
}
